module.exports = __webpack_public_path__ + "img/SmallscaleBurnDetailed-min.cccff6d2.png";